<template>
  <div class="gaurav-impex-logo d-flex align-center">
    <AppLogo
      :class="{
        'small-logo': variant == 'small',
        'x-medium-logo': variant == 'x-medium',
        'medium-logo': variant == 'medium',
        'large-logo': variant == 'large'
      }"
    />
    <div
      :class="{
        'logo-title': true,
        'large-font ml-2 mb-2': variant == 'large',
        'x-medium-font ml-2 mb-2': variant == 'x-medium',
        'medium-font ml-2 mb-2': variant == 'medium',
        'small-font ml-1 mb-1': variant == 'small'
      }"
    >
      {{ appName }}
    </div>
  </div>
</template>
<script>
import AppLogo from "./AppLogo";
import config from "@/config.js";
export default {
  name: "GauravImpexLogo",
  components: {
    AppLogo
  },
  props: {
    variant: {
      type: String,
      default: "large",
      required: true
    }
  },
  computed: {
    appName() {
      return config.appTitle();
    }
  }
};
</script>
<style lang="scss">
.gaurav-impex-logo {
  .large-font {
    font-size: 3.1rem;
    font-weight: 600;
  }
  .x-medium-font {
    font-size: 2.4rem;
    font-weight: 600;
  }
  .medium-font {
    font-size: 1.6rem;
    font-weight: 600;
  }
  .small-font {
    font-size: 1.2rem;
    font-weight: 600;
  }
  .large-logo {
    width: inherit;
  }
  .x-medium-logo {
    width: 4.4rem;
  }
  .medium-logo {
    width: 3.15rem;
  }
  .small-logo {
    width: 2.15rem;
  }
}
</style>
